import React, { useEffect, useState } from 'react';
import CardItem from './CardItem';
import { Row, Col, Button } from 'react-bootstrap';
import { CONFIG } from '../utils/config';

const ListItems = props => {
  const allPosts = props.data;
  const showPostNumber = CONFIG.SHOW_ITEMS_NUMBER;
  const [list, setList] = useState([...allPosts.slice(0, showPostNumber)]);

  // Trigger Load more.
  const [loadMore, setLoadMore] = useState(false);

  // Check if more items to load.
  const [hasMore, setHasMore] = useState(allPosts.length > showPostNumber);

  const handleLoadMore = () => {
    setLoadMore(true);
  };

  // Handle loading nodes.
  useEffect(() => {
    if (loadMore && hasMore) {
      const currentLength = list.length;
      const isMore = currentLength < allPosts.length;
      const nextResults = isMore
        ? allPosts.slice(currentLength, currentLength + showPostNumber)
        : [];
      setList([...list, ...nextResults]);
      setLoadMore();
    }
  }, [loadMore, hasMore]);

  // Check if more nodes.
  useEffect(() => {
    const isMore = list.length < allPosts.length;
    setHasMore(isMore);
  }, [list]);

  return (
    <>
      <Row>
        {list.map(item => (
          <CardItem data={item} key={item.nid} />
        ))}
      </Row>
      <Row>
        {hasMore ? (
          <Col className="mx-auto col-md-2">
            <Button
              className="mx-auto loadmorebtn fw-800 mx-auto"
              onClick={handleLoadMore}
            >
              Load More
            </Button>
          </Col>
        ) : (
          <Col>
            <p className="text-center fw-800">No more results</p>
          </Col>
        )}
      </Row>
    </>
  );
};

export default ListItems;
